/**
 * Generated by orval v8.0.0 🍺
 * Do not edit manually.
 * FabControl API
 * OpenAPI spec version: 1.0.0
 */
import {
  useQuery,
  useSuspenseQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult
} from '@tanstack/react-query';

import type {
  BaseResponse,
  POLineGetChecklistStatusPathParameters,
  POLineGetLinkedDeliveriesParams,
  POLineGetLinkedDeliveriesPathParameters,
  POLineGetQcItpStatusPathParameters,
  POLineGetReleaseReadinessPathParameters,
  POLineGetSummaryPathParameters,
  POLineGetTraceabilityCertificatesStatusPathParameters,
  PoLineChecklistStatusResponse,
  PoLineLinkedDeliveriesPagedResponse,
  PoLineQcItpStatusResponse,
  PoLineReleaseReadinessResponse,
  PoLineSummaryResponse,
  PoLineTraceabilityCertsResponse
} from '.././model';

import { apiInstance } from '../../instance';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



/**
 * @summary Get PO Line summary
 */
export const pOLineGetSummary = (
    { identifier, id }: POLineGetSummaryPathParameters,
 options?: SecondParameter<typeof apiInstance>,signal?: AbortSignal
) => {
      
      
      return apiInstance<PoLineSummaryResponse>(
      {url: `/api/poLines/${identifier}/getSummary/${id}`, method: 'GET', signal
    },
      options);
    }
  



export const getPOLineGetSummaryQueryKey = ({ identifier, id }: POLineGetSummaryPathParameters,) => {
    return [
    `/api/poLines/${identifier}/getSummary/${id}`
    ] as const;
    }

    
export const getPOLineGetSummaryQueryOptions = <TData = Awaited<ReturnType<typeof pOLineGetSummary>>, TError = BaseResponse>({ identifier, id }: POLineGetSummaryPathParameters, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof pOLineGetSummary>>, TError, TData>>, request?: SecondParameter<typeof apiInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};


  const queryKey =  queryOptions?.queryKey ?? getPOLineGetSummaryQueryKey({ identifier, id });

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof pOLineGetSummary>>> = ({ signal }) => pOLineGetSummary({ identifier, id }, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(identifier && id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof pOLineGetSummary>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type POLineGetSummaryQueryResult = NonNullable<Awaited<ReturnType<typeof pOLineGetSummary>>>
export type POLineGetSummaryQueryError = BaseResponse


export function usePOLineGetSummary<TData = Awaited<ReturnType<typeof pOLineGetSummary>>, TError = BaseResponse>(
 pathParams: POLineGetSummaryPathParameters, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof pOLineGetSummary>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof pOLineGetSummary>>,
          TError,
          Awaited<ReturnType<typeof pOLineGetSummary>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePOLineGetSummary<TData = Awaited<ReturnType<typeof pOLineGetSummary>>, TError = BaseResponse>(
 pathParams: POLineGetSummaryPathParameters, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof pOLineGetSummary>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof pOLineGetSummary>>,
          TError,
          Awaited<ReturnType<typeof pOLineGetSummary>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePOLineGetSummary<TData = Awaited<ReturnType<typeof pOLineGetSummary>>, TError = BaseResponse>(
 pathParams: POLineGetSummaryPathParameters, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof pOLineGetSummary>>, TError, TData>>, request?: SecondParameter<typeof apiInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get PO Line summary
 */

export function usePOLineGetSummary<TData = Awaited<ReturnType<typeof pOLineGetSummary>>, TError = BaseResponse>(
 { identifier, id }: POLineGetSummaryPathParameters, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof pOLineGetSummary>>, TError, TData>>, request?: SecondParameter<typeof apiInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getPOLineGetSummaryQueryOptions({ identifier, id },options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}




export const getPOLineGetSummarySuspenseQueryOptions = <TData = Awaited<ReturnType<typeof pOLineGetSummary>>, TError = BaseResponse>({ identifier, id }: POLineGetSummaryPathParameters, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof pOLineGetSummary>>, TError, TData>>, request?: SecondParameter<typeof apiInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};


  const queryKey =  queryOptions?.queryKey ?? getPOLineGetSummaryQueryKey({ identifier, id });

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof pOLineGetSummary>>> = ({ signal }) => pOLineGetSummary({ identifier, id }, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof pOLineGetSummary>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type POLineGetSummarySuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof pOLineGetSummary>>>
export type POLineGetSummarySuspenseQueryError = BaseResponse


export function usePOLineGetSummarySuspense<TData = Awaited<ReturnType<typeof pOLineGetSummary>>, TError = BaseResponse>(
 pathParams: POLineGetSummaryPathParameters, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof pOLineGetSummary>>, TError, TData>>, request?: SecondParameter<typeof apiInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePOLineGetSummarySuspense<TData = Awaited<ReturnType<typeof pOLineGetSummary>>, TError = BaseResponse>(
 pathParams: POLineGetSummaryPathParameters, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof pOLineGetSummary>>, TError, TData>>, request?: SecondParameter<typeof apiInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePOLineGetSummarySuspense<TData = Awaited<ReturnType<typeof pOLineGetSummary>>, TError = BaseResponse>(
 pathParams: POLineGetSummaryPathParameters, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof pOLineGetSummary>>, TError, TData>>, request?: SecondParameter<typeof apiInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get PO Line summary
 */

export function usePOLineGetSummarySuspense<TData = Awaited<ReturnType<typeof pOLineGetSummary>>, TError = BaseResponse>(
 { identifier, id }: POLineGetSummaryPathParameters, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof pOLineGetSummary>>, TError, TData>>, request?: SecondParameter<typeof apiInstance>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getPOLineGetSummarySuspenseQueryOptions({ identifier, id },options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}




/**
 * @summary Get PO Line checklist status
 */
export const pOLineGetChecklistStatus = (
    { identifier, id }: POLineGetChecklistStatusPathParameters,
 options?: SecondParameter<typeof apiInstance>,signal?: AbortSignal
) => {
      
      
      return apiInstance<PoLineChecklistStatusResponse>(
      {url: `/api/poLines/${identifier}/getChecklistStatus/${id}`, method: 'GET', signal
    },
      options);
    }
  



export const getPOLineGetChecklistStatusQueryKey = ({ identifier, id }: POLineGetChecklistStatusPathParameters,) => {
    return [
    `/api/poLines/${identifier}/getChecklistStatus/${id}`
    ] as const;
    }

    
export const getPOLineGetChecklistStatusQueryOptions = <TData = Awaited<ReturnType<typeof pOLineGetChecklistStatus>>, TError = BaseResponse>({ identifier, id }: POLineGetChecklistStatusPathParameters, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof pOLineGetChecklistStatus>>, TError, TData>>, request?: SecondParameter<typeof apiInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};


  const queryKey =  queryOptions?.queryKey ?? getPOLineGetChecklistStatusQueryKey({ identifier, id });

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof pOLineGetChecklistStatus>>> = ({ signal }) => pOLineGetChecklistStatus({ identifier, id }, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(identifier && id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof pOLineGetChecklistStatus>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type POLineGetChecklistStatusQueryResult = NonNullable<Awaited<ReturnType<typeof pOLineGetChecklistStatus>>>
export type POLineGetChecklistStatusQueryError = BaseResponse


export function usePOLineGetChecklistStatus<TData = Awaited<ReturnType<typeof pOLineGetChecklistStatus>>, TError = BaseResponse>(
 pathParams: POLineGetChecklistStatusPathParameters, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof pOLineGetChecklistStatus>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof pOLineGetChecklistStatus>>,
          TError,
          Awaited<ReturnType<typeof pOLineGetChecklistStatus>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePOLineGetChecklistStatus<TData = Awaited<ReturnType<typeof pOLineGetChecklistStatus>>, TError = BaseResponse>(
 pathParams: POLineGetChecklistStatusPathParameters, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof pOLineGetChecklistStatus>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof pOLineGetChecklistStatus>>,
          TError,
          Awaited<ReturnType<typeof pOLineGetChecklistStatus>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePOLineGetChecklistStatus<TData = Awaited<ReturnType<typeof pOLineGetChecklistStatus>>, TError = BaseResponse>(
 pathParams: POLineGetChecklistStatusPathParameters, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof pOLineGetChecklistStatus>>, TError, TData>>, request?: SecondParameter<typeof apiInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get PO Line checklist status
 */

export function usePOLineGetChecklistStatus<TData = Awaited<ReturnType<typeof pOLineGetChecklistStatus>>, TError = BaseResponse>(
 { identifier, id }: POLineGetChecklistStatusPathParameters, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof pOLineGetChecklistStatus>>, TError, TData>>, request?: SecondParameter<typeof apiInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getPOLineGetChecklistStatusQueryOptions({ identifier, id },options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}




export const getPOLineGetChecklistStatusSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof pOLineGetChecklistStatus>>, TError = BaseResponse>({ identifier, id }: POLineGetChecklistStatusPathParameters, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof pOLineGetChecklistStatus>>, TError, TData>>, request?: SecondParameter<typeof apiInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};


  const queryKey =  queryOptions?.queryKey ?? getPOLineGetChecklistStatusQueryKey({ identifier, id });

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof pOLineGetChecklistStatus>>> = ({ signal }) => pOLineGetChecklistStatus({ identifier, id }, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof pOLineGetChecklistStatus>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type POLineGetChecklistStatusSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof pOLineGetChecklistStatus>>>
export type POLineGetChecklistStatusSuspenseQueryError = BaseResponse


export function usePOLineGetChecklistStatusSuspense<TData = Awaited<ReturnType<typeof pOLineGetChecklistStatus>>, TError = BaseResponse>(
 pathParams: POLineGetChecklistStatusPathParameters, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof pOLineGetChecklistStatus>>, TError, TData>>, request?: SecondParameter<typeof apiInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePOLineGetChecklistStatusSuspense<TData = Awaited<ReturnType<typeof pOLineGetChecklistStatus>>, TError = BaseResponse>(
 pathParams: POLineGetChecklistStatusPathParameters, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof pOLineGetChecklistStatus>>, TError, TData>>, request?: SecondParameter<typeof apiInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePOLineGetChecklistStatusSuspense<TData = Awaited<ReturnType<typeof pOLineGetChecklistStatus>>, TError = BaseResponse>(
 pathParams: POLineGetChecklistStatusPathParameters, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof pOLineGetChecklistStatus>>, TError, TData>>, request?: SecondParameter<typeof apiInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get PO Line checklist status
 */

export function usePOLineGetChecklistStatusSuspense<TData = Awaited<ReturnType<typeof pOLineGetChecklistStatus>>, TError = BaseResponse>(
 { identifier, id }: POLineGetChecklistStatusPathParameters, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof pOLineGetChecklistStatus>>, TError, TData>>, request?: SecondParameter<typeof apiInstance>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getPOLineGetChecklistStatusSuspenseQueryOptions({ identifier, id },options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}




/**
 * @summary Get linked deliveries for a PO Line (paginated)
 */
export const pOLineGetLinkedDeliveries = (
    { identifier, id }: POLineGetLinkedDeliveriesPathParameters,
    params?: POLineGetLinkedDeliveriesParams,
 options?: SecondParameter<typeof apiInstance>,signal?: AbortSignal
) => {
      
      
      return apiInstance<PoLineLinkedDeliveriesPagedResponse>(
      {url: `/api/poLines/${identifier}/getLinkedDeliveries/${id}`, method: 'GET',
        params, signal
    },
      options);
    }
  



export const getPOLineGetLinkedDeliveriesQueryKey = ({ identifier, id }: POLineGetLinkedDeliveriesPathParameters,
    params?: POLineGetLinkedDeliveriesParams,) => {
    return [
    `/api/poLines/${identifier}/getLinkedDeliveries/${id}`, ...(params ? [params] : [])
    ] as const;
    }

    
export const getPOLineGetLinkedDeliveriesQueryOptions = <TData = Awaited<ReturnType<typeof pOLineGetLinkedDeliveries>>, TError = BaseResponse>({ identifier, id }: POLineGetLinkedDeliveriesPathParameters,
    params?: POLineGetLinkedDeliveriesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof pOLineGetLinkedDeliveries>>, TError, TData>>, request?: SecondParameter<typeof apiInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};


  const queryKey =  queryOptions?.queryKey ?? getPOLineGetLinkedDeliveriesQueryKey({ identifier, id },params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof pOLineGetLinkedDeliveries>>> = ({ signal }) => pOLineGetLinkedDeliveries({ identifier, id },params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(identifier && id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof pOLineGetLinkedDeliveries>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type POLineGetLinkedDeliveriesQueryResult = NonNullable<Awaited<ReturnType<typeof pOLineGetLinkedDeliveries>>>
export type POLineGetLinkedDeliveriesQueryError = BaseResponse


export function usePOLineGetLinkedDeliveries<TData = Awaited<ReturnType<typeof pOLineGetLinkedDeliveries>>, TError = BaseResponse>(
 pathParams: POLineGetLinkedDeliveriesPathParameters,
    params: undefined |  POLineGetLinkedDeliveriesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof pOLineGetLinkedDeliveries>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof pOLineGetLinkedDeliveries>>,
          TError,
          Awaited<ReturnType<typeof pOLineGetLinkedDeliveries>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePOLineGetLinkedDeliveries<TData = Awaited<ReturnType<typeof pOLineGetLinkedDeliveries>>, TError = BaseResponse>(
 pathParams: POLineGetLinkedDeliveriesPathParameters,
    params?: POLineGetLinkedDeliveriesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof pOLineGetLinkedDeliveries>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof pOLineGetLinkedDeliveries>>,
          TError,
          Awaited<ReturnType<typeof pOLineGetLinkedDeliveries>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePOLineGetLinkedDeliveries<TData = Awaited<ReturnType<typeof pOLineGetLinkedDeliveries>>, TError = BaseResponse>(
 pathParams: POLineGetLinkedDeliveriesPathParameters,
    params?: POLineGetLinkedDeliveriesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof pOLineGetLinkedDeliveries>>, TError, TData>>, request?: SecondParameter<typeof apiInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get linked deliveries for a PO Line (paginated)
 */

export function usePOLineGetLinkedDeliveries<TData = Awaited<ReturnType<typeof pOLineGetLinkedDeliveries>>, TError = BaseResponse>(
 { identifier, id }: POLineGetLinkedDeliveriesPathParameters,
    params?: POLineGetLinkedDeliveriesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof pOLineGetLinkedDeliveries>>, TError, TData>>, request?: SecondParameter<typeof apiInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getPOLineGetLinkedDeliveriesQueryOptions({ identifier, id },params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}




export const getPOLineGetLinkedDeliveriesSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof pOLineGetLinkedDeliveries>>, TError = BaseResponse>({ identifier, id }: POLineGetLinkedDeliveriesPathParameters,
    params?: POLineGetLinkedDeliveriesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof pOLineGetLinkedDeliveries>>, TError, TData>>, request?: SecondParameter<typeof apiInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};


  const queryKey =  queryOptions?.queryKey ?? getPOLineGetLinkedDeliveriesQueryKey({ identifier, id },params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof pOLineGetLinkedDeliveries>>> = ({ signal }) => pOLineGetLinkedDeliveries({ identifier, id },params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof pOLineGetLinkedDeliveries>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type POLineGetLinkedDeliveriesSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof pOLineGetLinkedDeliveries>>>
export type POLineGetLinkedDeliveriesSuspenseQueryError = BaseResponse


export function usePOLineGetLinkedDeliveriesSuspense<TData = Awaited<ReturnType<typeof pOLineGetLinkedDeliveries>>, TError = BaseResponse>(
 pathParams: POLineGetLinkedDeliveriesPathParameters,
    params: undefined |  POLineGetLinkedDeliveriesParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof pOLineGetLinkedDeliveries>>, TError, TData>>, request?: SecondParameter<typeof apiInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePOLineGetLinkedDeliveriesSuspense<TData = Awaited<ReturnType<typeof pOLineGetLinkedDeliveries>>, TError = BaseResponse>(
 pathParams: POLineGetLinkedDeliveriesPathParameters,
    params?: POLineGetLinkedDeliveriesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof pOLineGetLinkedDeliveries>>, TError, TData>>, request?: SecondParameter<typeof apiInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePOLineGetLinkedDeliveriesSuspense<TData = Awaited<ReturnType<typeof pOLineGetLinkedDeliveries>>, TError = BaseResponse>(
 pathParams: POLineGetLinkedDeliveriesPathParameters,
    params?: POLineGetLinkedDeliveriesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof pOLineGetLinkedDeliveries>>, TError, TData>>, request?: SecondParameter<typeof apiInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get linked deliveries for a PO Line (paginated)
 */

export function usePOLineGetLinkedDeliveriesSuspense<TData = Awaited<ReturnType<typeof pOLineGetLinkedDeliveries>>, TError = BaseResponse>(
 { identifier, id }: POLineGetLinkedDeliveriesPathParameters,
    params?: POLineGetLinkedDeliveriesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof pOLineGetLinkedDeliveries>>, TError, TData>>, request?: SecondParameter<typeof apiInstance>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getPOLineGetLinkedDeliveriesSuspenseQueryOptions({ identifier, id },params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}




/**
 * @summary Get PO Line release readiness status
 */
export const pOLineGetReleaseReadiness = (
    { identifier, id }: POLineGetReleaseReadinessPathParameters,
 options?: SecondParameter<typeof apiInstance>,signal?: AbortSignal
) => {
      
      
      return apiInstance<PoLineReleaseReadinessResponse>(
      {url: `/api/poLines/${identifier}/getReleaseReadiness/${id}`, method: 'GET', signal
    },
      options);
    }
  



export const getPOLineGetReleaseReadinessQueryKey = ({ identifier, id }: POLineGetReleaseReadinessPathParameters,) => {
    return [
    `/api/poLines/${identifier}/getReleaseReadiness/${id}`
    ] as const;
    }

    
export const getPOLineGetReleaseReadinessQueryOptions = <TData = Awaited<ReturnType<typeof pOLineGetReleaseReadiness>>, TError = BaseResponse>({ identifier, id }: POLineGetReleaseReadinessPathParameters, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof pOLineGetReleaseReadiness>>, TError, TData>>, request?: SecondParameter<typeof apiInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};


  const queryKey =  queryOptions?.queryKey ?? getPOLineGetReleaseReadinessQueryKey({ identifier, id });

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof pOLineGetReleaseReadiness>>> = ({ signal }) => pOLineGetReleaseReadiness({ identifier, id }, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(identifier && id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof pOLineGetReleaseReadiness>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type POLineGetReleaseReadinessQueryResult = NonNullable<Awaited<ReturnType<typeof pOLineGetReleaseReadiness>>>
export type POLineGetReleaseReadinessQueryError = BaseResponse


export function usePOLineGetReleaseReadiness<TData = Awaited<ReturnType<typeof pOLineGetReleaseReadiness>>, TError = BaseResponse>(
 pathParams: POLineGetReleaseReadinessPathParameters, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof pOLineGetReleaseReadiness>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof pOLineGetReleaseReadiness>>,
          TError,
          Awaited<ReturnType<typeof pOLineGetReleaseReadiness>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePOLineGetReleaseReadiness<TData = Awaited<ReturnType<typeof pOLineGetReleaseReadiness>>, TError = BaseResponse>(
 pathParams: POLineGetReleaseReadinessPathParameters, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof pOLineGetReleaseReadiness>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof pOLineGetReleaseReadiness>>,
          TError,
          Awaited<ReturnType<typeof pOLineGetReleaseReadiness>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePOLineGetReleaseReadiness<TData = Awaited<ReturnType<typeof pOLineGetReleaseReadiness>>, TError = BaseResponse>(
 pathParams: POLineGetReleaseReadinessPathParameters, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof pOLineGetReleaseReadiness>>, TError, TData>>, request?: SecondParameter<typeof apiInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get PO Line release readiness status
 */

export function usePOLineGetReleaseReadiness<TData = Awaited<ReturnType<typeof pOLineGetReleaseReadiness>>, TError = BaseResponse>(
 { identifier, id }: POLineGetReleaseReadinessPathParameters, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof pOLineGetReleaseReadiness>>, TError, TData>>, request?: SecondParameter<typeof apiInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getPOLineGetReleaseReadinessQueryOptions({ identifier, id },options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}




export const getPOLineGetReleaseReadinessSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof pOLineGetReleaseReadiness>>, TError = BaseResponse>({ identifier, id }: POLineGetReleaseReadinessPathParameters, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof pOLineGetReleaseReadiness>>, TError, TData>>, request?: SecondParameter<typeof apiInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};


  const queryKey =  queryOptions?.queryKey ?? getPOLineGetReleaseReadinessQueryKey({ identifier, id });

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof pOLineGetReleaseReadiness>>> = ({ signal }) => pOLineGetReleaseReadiness({ identifier, id }, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof pOLineGetReleaseReadiness>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type POLineGetReleaseReadinessSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof pOLineGetReleaseReadiness>>>
export type POLineGetReleaseReadinessSuspenseQueryError = BaseResponse


export function usePOLineGetReleaseReadinessSuspense<TData = Awaited<ReturnType<typeof pOLineGetReleaseReadiness>>, TError = BaseResponse>(
 pathParams: POLineGetReleaseReadinessPathParameters, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof pOLineGetReleaseReadiness>>, TError, TData>>, request?: SecondParameter<typeof apiInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePOLineGetReleaseReadinessSuspense<TData = Awaited<ReturnType<typeof pOLineGetReleaseReadiness>>, TError = BaseResponse>(
 pathParams: POLineGetReleaseReadinessPathParameters, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof pOLineGetReleaseReadiness>>, TError, TData>>, request?: SecondParameter<typeof apiInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePOLineGetReleaseReadinessSuspense<TData = Awaited<ReturnType<typeof pOLineGetReleaseReadiness>>, TError = BaseResponse>(
 pathParams: POLineGetReleaseReadinessPathParameters, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof pOLineGetReleaseReadiness>>, TError, TData>>, request?: SecondParameter<typeof apiInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get PO Line release readiness status
 */

export function usePOLineGetReleaseReadinessSuspense<TData = Awaited<ReturnType<typeof pOLineGetReleaseReadiness>>, TError = BaseResponse>(
 { identifier, id }: POLineGetReleaseReadinessPathParameters, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof pOLineGetReleaseReadiness>>, TError, TData>>, request?: SecondParameter<typeof apiInstance>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getPOLineGetReleaseReadinessSuspenseQueryOptions({ identifier, id },options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}




/**
 * @summary Get traceability & certificates status for a PO Line
 */
export const pOLineGetTraceabilityCertificatesStatus = (
    { identifier, id }: POLineGetTraceabilityCertificatesStatusPathParameters,
 options?: SecondParameter<typeof apiInstance>,signal?: AbortSignal
) => {
      
      
      return apiInstance<PoLineTraceabilityCertsResponse>(
      {url: `/api/poLines/${identifier}/getTraceabilityCertificatesStatus/${id}`, method: 'GET', signal
    },
      options);
    }
  



export const getPOLineGetTraceabilityCertificatesStatusQueryKey = ({ identifier, id }: POLineGetTraceabilityCertificatesStatusPathParameters,) => {
    return [
    `/api/poLines/${identifier}/getTraceabilityCertificatesStatus/${id}`
    ] as const;
    }

    
export const getPOLineGetTraceabilityCertificatesStatusQueryOptions = <TData = Awaited<ReturnType<typeof pOLineGetTraceabilityCertificatesStatus>>, TError = BaseResponse>({ identifier, id }: POLineGetTraceabilityCertificatesStatusPathParameters, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof pOLineGetTraceabilityCertificatesStatus>>, TError, TData>>, request?: SecondParameter<typeof apiInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};


  const queryKey =  queryOptions?.queryKey ?? getPOLineGetTraceabilityCertificatesStatusQueryKey({ identifier, id });

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof pOLineGetTraceabilityCertificatesStatus>>> = ({ signal }) => pOLineGetTraceabilityCertificatesStatus({ identifier, id }, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(identifier && id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof pOLineGetTraceabilityCertificatesStatus>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type POLineGetTraceabilityCertificatesStatusQueryResult = NonNullable<Awaited<ReturnType<typeof pOLineGetTraceabilityCertificatesStatus>>>
export type POLineGetTraceabilityCertificatesStatusQueryError = BaseResponse


export function usePOLineGetTraceabilityCertificatesStatus<TData = Awaited<ReturnType<typeof pOLineGetTraceabilityCertificatesStatus>>, TError = BaseResponse>(
 pathParams: POLineGetTraceabilityCertificatesStatusPathParameters, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof pOLineGetTraceabilityCertificatesStatus>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof pOLineGetTraceabilityCertificatesStatus>>,
          TError,
          Awaited<ReturnType<typeof pOLineGetTraceabilityCertificatesStatus>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePOLineGetTraceabilityCertificatesStatus<TData = Awaited<ReturnType<typeof pOLineGetTraceabilityCertificatesStatus>>, TError = BaseResponse>(
 pathParams: POLineGetTraceabilityCertificatesStatusPathParameters, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof pOLineGetTraceabilityCertificatesStatus>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof pOLineGetTraceabilityCertificatesStatus>>,
          TError,
          Awaited<ReturnType<typeof pOLineGetTraceabilityCertificatesStatus>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePOLineGetTraceabilityCertificatesStatus<TData = Awaited<ReturnType<typeof pOLineGetTraceabilityCertificatesStatus>>, TError = BaseResponse>(
 pathParams: POLineGetTraceabilityCertificatesStatusPathParameters, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof pOLineGetTraceabilityCertificatesStatus>>, TError, TData>>, request?: SecondParameter<typeof apiInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get traceability & certificates status for a PO Line
 */

export function usePOLineGetTraceabilityCertificatesStatus<TData = Awaited<ReturnType<typeof pOLineGetTraceabilityCertificatesStatus>>, TError = BaseResponse>(
 { identifier, id }: POLineGetTraceabilityCertificatesStatusPathParameters, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof pOLineGetTraceabilityCertificatesStatus>>, TError, TData>>, request?: SecondParameter<typeof apiInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getPOLineGetTraceabilityCertificatesStatusQueryOptions({ identifier, id },options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}




export const getPOLineGetTraceabilityCertificatesStatusSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof pOLineGetTraceabilityCertificatesStatus>>, TError = BaseResponse>({ identifier, id }: POLineGetTraceabilityCertificatesStatusPathParameters, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof pOLineGetTraceabilityCertificatesStatus>>, TError, TData>>, request?: SecondParameter<typeof apiInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};


  const queryKey =  queryOptions?.queryKey ?? getPOLineGetTraceabilityCertificatesStatusQueryKey({ identifier, id });

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof pOLineGetTraceabilityCertificatesStatus>>> = ({ signal }) => pOLineGetTraceabilityCertificatesStatus({ identifier, id }, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof pOLineGetTraceabilityCertificatesStatus>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type POLineGetTraceabilityCertificatesStatusSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof pOLineGetTraceabilityCertificatesStatus>>>
export type POLineGetTraceabilityCertificatesStatusSuspenseQueryError = BaseResponse


export function usePOLineGetTraceabilityCertificatesStatusSuspense<TData = Awaited<ReturnType<typeof pOLineGetTraceabilityCertificatesStatus>>, TError = BaseResponse>(
 pathParams: POLineGetTraceabilityCertificatesStatusPathParameters, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof pOLineGetTraceabilityCertificatesStatus>>, TError, TData>>, request?: SecondParameter<typeof apiInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePOLineGetTraceabilityCertificatesStatusSuspense<TData = Awaited<ReturnType<typeof pOLineGetTraceabilityCertificatesStatus>>, TError = BaseResponse>(
 pathParams: POLineGetTraceabilityCertificatesStatusPathParameters, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof pOLineGetTraceabilityCertificatesStatus>>, TError, TData>>, request?: SecondParameter<typeof apiInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePOLineGetTraceabilityCertificatesStatusSuspense<TData = Awaited<ReturnType<typeof pOLineGetTraceabilityCertificatesStatus>>, TError = BaseResponse>(
 pathParams: POLineGetTraceabilityCertificatesStatusPathParameters, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof pOLineGetTraceabilityCertificatesStatus>>, TError, TData>>, request?: SecondParameter<typeof apiInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get traceability & certificates status for a PO Line
 */

export function usePOLineGetTraceabilityCertificatesStatusSuspense<TData = Awaited<ReturnType<typeof pOLineGetTraceabilityCertificatesStatus>>, TError = BaseResponse>(
 { identifier, id }: POLineGetTraceabilityCertificatesStatusPathParameters, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof pOLineGetTraceabilityCertificatesStatus>>, TError, TData>>, request?: SecondParameter<typeof apiInstance>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getPOLineGetTraceabilityCertificatesStatusSuspenseQueryOptions({ identifier, id },options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}




/**
 * @summary Get QC / ITP status for a PO Line
 */
export const pOLineGetQcItpStatus = (
    { identifier, id }: POLineGetQcItpStatusPathParameters,
 options?: SecondParameter<typeof apiInstance>,signal?: AbortSignal
) => {
      
      
      return apiInstance<PoLineQcItpStatusResponse>(
      {url: `/api/poLines/${identifier}/getQcItpStatus/${id}`, method: 'GET', signal
    },
      options);
    }
  



export const getPOLineGetQcItpStatusQueryKey = ({ identifier, id }: POLineGetQcItpStatusPathParameters,) => {
    return [
    `/api/poLines/${identifier}/getQcItpStatus/${id}`
    ] as const;
    }

    
export const getPOLineGetQcItpStatusQueryOptions = <TData = Awaited<ReturnType<typeof pOLineGetQcItpStatus>>, TError = BaseResponse>({ identifier, id }: POLineGetQcItpStatusPathParameters, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof pOLineGetQcItpStatus>>, TError, TData>>, request?: SecondParameter<typeof apiInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};


  const queryKey =  queryOptions?.queryKey ?? getPOLineGetQcItpStatusQueryKey({ identifier, id });

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof pOLineGetQcItpStatus>>> = ({ signal }) => pOLineGetQcItpStatus({ identifier, id }, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(identifier && id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof pOLineGetQcItpStatus>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type POLineGetQcItpStatusQueryResult = NonNullable<Awaited<ReturnType<typeof pOLineGetQcItpStatus>>>
export type POLineGetQcItpStatusQueryError = BaseResponse


export function usePOLineGetQcItpStatus<TData = Awaited<ReturnType<typeof pOLineGetQcItpStatus>>, TError = BaseResponse>(
 pathParams: POLineGetQcItpStatusPathParameters, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof pOLineGetQcItpStatus>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof pOLineGetQcItpStatus>>,
          TError,
          Awaited<ReturnType<typeof pOLineGetQcItpStatus>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePOLineGetQcItpStatus<TData = Awaited<ReturnType<typeof pOLineGetQcItpStatus>>, TError = BaseResponse>(
 pathParams: POLineGetQcItpStatusPathParameters, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof pOLineGetQcItpStatus>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof pOLineGetQcItpStatus>>,
          TError,
          Awaited<ReturnType<typeof pOLineGetQcItpStatus>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePOLineGetQcItpStatus<TData = Awaited<ReturnType<typeof pOLineGetQcItpStatus>>, TError = BaseResponse>(
 pathParams: POLineGetQcItpStatusPathParameters, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof pOLineGetQcItpStatus>>, TError, TData>>, request?: SecondParameter<typeof apiInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get QC / ITP status for a PO Line
 */

export function usePOLineGetQcItpStatus<TData = Awaited<ReturnType<typeof pOLineGetQcItpStatus>>, TError = BaseResponse>(
 { identifier, id }: POLineGetQcItpStatusPathParameters, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof pOLineGetQcItpStatus>>, TError, TData>>, request?: SecondParameter<typeof apiInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getPOLineGetQcItpStatusQueryOptions({ identifier, id },options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}




export const getPOLineGetQcItpStatusSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof pOLineGetQcItpStatus>>, TError = BaseResponse>({ identifier, id }: POLineGetQcItpStatusPathParameters, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof pOLineGetQcItpStatus>>, TError, TData>>, request?: SecondParameter<typeof apiInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};


  const queryKey =  queryOptions?.queryKey ?? getPOLineGetQcItpStatusQueryKey({ identifier, id });

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof pOLineGetQcItpStatus>>> = ({ signal }) => pOLineGetQcItpStatus({ identifier, id }, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof pOLineGetQcItpStatus>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type POLineGetQcItpStatusSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof pOLineGetQcItpStatus>>>
export type POLineGetQcItpStatusSuspenseQueryError = BaseResponse


export function usePOLineGetQcItpStatusSuspense<TData = Awaited<ReturnType<typeof pOLineGetQcItpStatus>>, TError = BaseResponse>(
 pathParams: POLineGetQcItpStatusPathParameters, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof pOLineGetQcItpStatus>>, TError, TData>>, request?: SecondParameter<typeof apiInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePOLineGetQcItpStatusSuspense<TData = Awaited<ReturnType<typeof pOLineGetQcItpStatus>>, TError = BaseResponse>(
 pathParams: POLineGetQcItpStatusPathParameters, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof pOLineGetQcItpStatus>>, TError, TData>>, request?: SecondParameter<typeof apiInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePOLineGetQcItpStatusSuspense<TData = Awaited<ReturnType<typeof pOLineGetQcItpStatus>>, TError = BaseResponse>(
 pathParams: POLineGetQcItpStatusPathParameters, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof pOLineGetQcItpStatus>>, TError, TData>>, request?: SecondParameter<typeof apiInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get QC / ITP status for a PO Line
 */

export function usePOLineGetQcItpStatusSuspense<TData = Awaited<ReturnType<typeof pOLineGetQcItpStatus>>, TError = BaseResponse>(
 { identifier, id }: POLineGetQcItpStatusPathParameters, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof pOLineGetQcItpStatus>>, TError, TData>>, request?: SecondParameter<typeof apiInstance>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getPOLineGetQcItpStatusSuspenseQueryOptions({ identifier, id },options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}




